import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

import { Alert } from '@notablehealth/design-system';

export function NotFoundPage() {
  const url = window.location.href;
  useEffect(() => {
    const msg = `Route not found: ${url}`;
    Sentry.captureMessage(msg);
    console.error(msg);
  }, [url]);
  return (
    <Alert variant="warning" sx={{ margin: 3 }}>
      The page you’re looking for can’t be found.
    </Alert>
  );
}
